import perks from "./perks";
import admin from "./admin";
import insights from "./insights";
import recognition from "./recognition";
import platform from "./platform";
import wallet from "./wallet";
import medical from "./medical";
import merchant from "./merchant";
import PerkboxToken from "../../utils/PerkboxToken";
import omitEmpty from "./utils/omitEmpty";
import internal from "./internal";
export { admin };
export var getAllApps = function (auth) {
    var accessToken = auth.accessToken;
    var token = null;
    try {
        if (accessToken) {
            token = new PerkboxToken(accessToken);
        }
        else {
            throw Error();
        }
    }
    catch (e) {
        return omitEmpty({});
    }
    var obj = {
        perks: perks.get(token),
        admin: admin.get(token, auth),
        recognition: recognition.get(token, auth),
        insights: insights.get(token, auth),
        platform: platform.get(token, auth),
        wallet: wallet.get(token, auth),
        medical: medical.get(token),
        merchant: merchant.get(token),
        internal: internal.get(token, auth)
    };
    /** @author: Richard
      * We only want to add to object if permission is allowed.
      * This allows for Object.keys(apps) to get app count
      */
    return omitEmpty(obj) || {};
};
